module.exports = __webpack_public_path__ + "static/about-insta-7-38cb1bf0d84a852cf900dcff6148c479.jpg";